import { useEffect, useState } from "react";
import { getDashboardStats, getGroupStats } from "../../Api Methods/Api";
import { useDispatch, useSelector } from "react-redux";
import { Await } from "react-router-dom";
import Stats2 from "../../components/UI/Stats/Stats2";
import classes from './Dashboard.module.css'

const Dashboard = () => {
    const [stats, setStats] = useState();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const apiData = {
        token,
        client
    }
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const HandleGetStats = async () => {
            const response = await getDashboardStats(apiData, dispatch);
            console.log(response)
            setStats(response.data[0][0]);
            setIsLoading(false)
        }

        HandleGetStats()
    }, []);

    return (
        <div className={classes.pageContainer}>
            <Await resolve={stats}>
            {(loadedStats) => (
                   <div className={classes.container}>
                        {stats && <Stats2 title={"All sites"} value={loadedStats.sitesCount} isLoadingStats={isLoading} isStatic={true} />}
                        {stats && <Stats2 title={"Online sites"} value={(loadedStats.sitesCount - loadedStats.offlineCount)} isLoadingStats={isLoading} isStatic={true}/>}
                        {stats && <Stats2 title={"Active sites"} value={loadedStats.activeCount} isLoadingStats={isLoading} isStatic={true}/> }
                        {stats && <Stats2 title={"Inactive sites"} value={loadedStats.inactiveCount} isLoadingStats={isLoading} isStatic={true}/> }
                        {stats && <Stats2 title={"Controllers"} value={loadedStats.controllerCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeControllerCount}/> }
                        {stats && <Stats2 title={"Offline controllers"} value={loadedStats.offlineCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.offlineActiveCount}/>  } 
                        {stats && <Stats2 title={"Sites on schedule"} value={loadedStats.scheduleCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeScheduleCount}/> } 
                        {stats && <Stats2 title={"Users"} value={loadedStats.totalUserCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeTotalUserCount}/> }
                        {stats && <Stats2 title={"Groups"} value={loadedStats.accountsCount} isLoadingStats={isLoading} isStatic={true} /> }
                        {stats && <Stats2 title={"Padlocks"} value={loadedStats.lockCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeLockCount}/> }
                        {stats && <Stats2 title={"Billable padlocks"} value={loadedStats.billedLockCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={false}/> }
                        {stats && <Stats2 title={"Keyboxes"} value={loadedStats.keyboxCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeKeyboxCount}/> }
                        {stats && <Stats2 title={"Billable keyboxes"} value={loadedStats.billedKeyboxCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={false}/> }
                        {stats && <Stats2 title={"Sensors"} value={loadedStats.sensorCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeSensorCount}/> }
                        {stats && <Stats2 title={"Gateways"} value={loadedStats.gatewayCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeGatewayCount}/> }
                        {stats && <Stats2 title={"Total integrations"} value={loadedStats.totalIntegrations} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.totalActiveIntegrations}/> }
                        {stats && <Stats2 title={"AJAX"} value={loadedStats.ajaxCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeAjaxCount}/> }
                        {stats && <Stats2 title={"Dahua"} value={loadedStats.dahuaCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeDahuaCount}/> }
                        {stats && <Stats2 title={"Hikvision"} value={loadedStats.hikvisionCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeHikvisionCount}/> }
                        {stats && <Stats2 title={"AIBox"} value={loadedStats.aiboxCount} isLoadingStats={isLoading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeAiboxCount}/> }
                   </div>
                )}
            </Await>
        </div>
    )
}

export default Dashboard;